import { useState } from "react";
import '../styles/ui/modal.scss'


const SlideModal = ({children, images, changeTo}) => {
    
    const [modal, setModal] = useState(false)
    const [current, setCurrent] = useState(changeTo)
    
    const changeCurrent = (value) => {
        setCurrent(value)
    }
    const changeModal = (value) => {
        setModal(value)
    }

    const arrowLeft = () => {
        current === 0 ? changeCurrent(images.length-1) : changeCurrent(current-1)
    }
    const arrowRight = () => {
        current === images.length-1 ? changeCurrent(0) : changeCurrent(current+1)
        console.log(current)
    }

    return (
        <div className="modal-container" >
            {
                modal && 
                <div className="modal-wrapper">
                    <div className="slide-wrapper">
                        <img src={`${process.env.PUBLIC_URL}${images[current]}`} alt="Slide" 
                            style={{
                                maxWidth: "1200px",
                                width: "90%"
                            }}
                        />
                        <div className="slide-nav">
                            <button className="modal-btn arrow-left" onClick={arrowLeft}></button>
                            <button className="modal-btn close" onClick = {()=>changeModal(false)}></button>
                            <button className="modal-btn arrow-right" onClick={arrowRight}></button>
                        </div>
                    </div>
                </div>
            }
            <div className="modal-button" onClick={()=>{
                changeModal(true)
                changeCurrent(changeTo)
            }} >
                { children }
            </div>
        </div>
    )
}

export default SlideModal;